// import React from "react";

import Login from "./auth/Login";
import Session from "./auth/Session";
import Dashboard from "./dashboard";
import Users from "./users";
import UserEdit from "./users/UserEdit";
import Roles from "./acl/Roles";
import PermissionsPage from "./acl/PermissionsPage";
import RoleEdit from "./acl/RoleEdit";
import Articles from "./articles";
import ArticleEdit from "./articles/ArticleEdit";
import Applications from "./applications";
import ApplicationEdit from "./applications/ApplicationEdit";
import Pages from "./pages";
import PageEdit from "./pages/PageEdit";
import Books from "./books";
import BookEdit from "./books/BookEdit";
import Queues from "./queues";
import QueueEdit from "./queues/QueueEdit";
import Sections from "./sections";
import SectionEdit from "./sections/SectionEdit";
import Cards from "./cards";
import CardEdit from "./cards/CardEdit";
import Events from "./events";
import EventEdit from "./events/EventEdit";
import Educations from "./educations";
import EducationEdit from "./educations/EducationEdit";
import Menus from "./navigation/Menus";
import MenuEdit from "./navigation/MenuEdit";
import Groups from "./groups";
import GroupRoles from "./groups/GroupRoles";
import GroupsRoleEdit from "./groups/GroupsRoleEdit";
import GroupPermissions from "./groups/GroupPermissions";
import GroupEdit from "./groups/GroupEdit";
import Docs from "./docs";
import GeneralStatistics from "./statistics/General";
import CertificationsStatistics from "./statistics/Certifications";
import Settings from "./settings";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import VoGroups from "@vocollege/app/dist/modules/VoGroups";

interface Routes {
  [key: string]: any;
}

const routes: Routes = {
  auth: {
    abilities: false,
    path: "/auth",
    hideHeader: true,
  },
  login: {
    abilities: false,
    path: "/login",
    component: Login,
    hideHeader: true,
  },
  session: {
    abilities: false,
    path: "/session",
    component: Session,
    hideHeader: true,
  },
  root: {
    abilities: true,
    path: "/",
    component: Dashboard,
    label: I18n.get.misc.start,
  },

  // Acl.

  acl: {
    path: "/acl",
    label: I18n.get.misc.acl,
  },
  "acl.roles.id": {
    path: "/acl/roles/:id",
    component: RoleEdit,
    abilities: [
      {
        action: "manage",
        subject: "Roles",
      },
    ],
  },
  "acl.roles": {
    path: "/acl/roles",
    component: Roles,
    label: I18n.get.misc.roles,
    abilities: [
      {
        action: "manage",
        subject: "Roles",
      },
    ],
  },
  "acl.permissions": {
    path: "/acl/permissions",
    component: PermissionsPage,
    label: I18n.get.misc.permissions,
    abilities: [
      {
        action: "manage",
        subject: "Permissions",
      },
    ],
  },

  // Users.

  users: {
    path: "/users",
    component: Users,
    label: I18n.get.misc.user,
    abilities: [
      {
        action: "list",
        subject: "Users",
      },
    ],
  },
  "users.id": {
    path: "/users/:id",
    component: UserEdit,
    abilities: [
      {
        action: "update",
        subject: "Users",
      },
    ],
  },

  // Content.

  content: {
    path: "/content",
    label: I18n.get.misc.content,
  },

  // Articles.

  "content.articles": {
    path: "/content/articles",
    label: I18n.get.misc.articles,
    component: Articles,
    abilities: [
      {
        action: "list",
        subject: "Articles",
      },
    ],
  },

  "content.articles.id": {
    path: "/content/articles/:id",
    component: ArticleEdit,
    abilities: [
      {
        action: "update",
        subject: "Articles",
      },
    ],
  },

  // Pages.

  "content.pages": {
    path: "/content/pages",
    label: I18n.get.misc.pages,
    component: Pages,
    abilities: [
      {
        action: "list",
        subject: "Pages",
      },
    ],
  },

  "content.pages.id": {
    path: "/content/pages/:id",
    component: PageEdit,
    abilities: [
      {
        action: "update",
        subject: "Pages",
      },
    ],
  },

  // Books.

  "content.books": {
    path: "/content/books",
    label: I18n.get.book.labels.books,
    component: Books,
    abilities: [
      {
        action: "list",
        subject: "Books",
      },
    ],
  },

  "content.books.id": {
    path: "/content/books/:id",
    component: BookEdit,
    abilities: [
      {
        action: "update",
        subject: "Books",
      },
    ],
  },

  // Queues.

  "content.queues": {
    path: "/content/queues",
    label: I18n.get.misc.queues,
    component: Queues,
    abilities: [
      {
        action: "list",
        subject: "Queues",
      },
    ],
  },

  "content.queues.id": {
    path: "/content/queues/:id",
    component: QueueEdit,
    abilities: [
      {
        action: "update",
        subject: "Queues",
      },
    ],
  },

  // Sections.

  "content.sections": {
    path: "/content/sections",
    label: I18n.get.section.labels.sections,
    component: Sections,
    abilities: [
      {
        action: "list",
        subject: "Sections",
      },
    ],
  },

  "content.sections.id": {
    path: "/content/sections/:id",
    component: SectionEdit,
    abilities: [
      {
        action: "update",
        subject: "Sections",
      },
    ],
  },

  // Events.

  "content.events": {
    path: "/content/events",
    label: I18n.get.event.labels.events,
    component: Events,
    abilities: [
      {
        action: "list",
        subject: "Events",
      },
    ],
  },

  "content.events.id": {
    path: "/content/events/:id",
    component: EventEdit,
    abilities: [
      {
        action: "update",
        subject: "Events",
      },
    ],
  },

  // Cards.

  "content.cards": {
    path: "/content/cards",
    label: I18n.get.card.labels.cards,
    component: Cards,
    abilities: [
      {
        action: "list",
        subject: "Cards",
      },
    ],
  },

  "content.cards.id": {
    path: "/content/cards/:id",
    component: CardEdit,
    abilities: [
      {
        action: "update",
        subject: "Cards",
      },
    ],
  },

  // Educations.

  "content.educations": {
    path: "/content/educations",
    label: I18n.get.education.labels.educations,
    component: Educations,
    abilities: [
      {
        action: "list",
        subject: "Educations",
      },
    ],
  },

  "content.educations.id": {
    path: "/content/educations/:id",
    component: EducationEdit,
    abilities: [
      {
        action: "update",
        subject: "Educations",
      },
    ],
  },

  // Groups.

  groups: {
    path: "/groups",
    label: I18n.get.group.labels.groups,
    component: Groups,
    abilities: [
      {
        action: "list_all",
        subject: "Groups",
      },
    ],
  },

  "groups.roles.id": {
    path: "/groups/roles/:id",
    component: GroupsRoleEdit,
    abilities: [
      {
        action: "manage_group_roles",
        subject: "Groups",
      },
    ],
  },

  "groups.roles": {
    path: "/groups/roles",
    label: I18n.get.misc.roles,
    component: GroupRoles,
    abilities: [
      {
        action: "manage_group_roles",
        subject: "Groups",
      },
    ],
  },

  "groups.permissions": {
    path: "/groups/permissions",
    label: I18n.get.misc.permissions,
    component: GroupPermissions,
    abilities: [
      {
        action: "manage_group_permissions",
        subject: "Groups",
      },
    ],
  },

  "groups.id": {
    path: "/groups/:id",
    component: GroupEdit,
    abilities: [
      {
        action: VoGroups.getCurrent() ? "manage" : "update",
        subject: VoGroups.getCurrent() ? "Group" : "Groups",
      },
    ],
  },

  // VO Docs.

  docs: {
    path: "/docs",
    label: I18n.get.misc.documentbank,
    component: Docs,
    abilities: [
      {
        action: "list_portfolios",
        subject: "Docs",
      },
    ],
  },

  "docs.portfolio": {
    path: "/docs/portfolio/:portfolioId",
    component: Docs,
    abilities: [
      {
        action: "view_portfolio",
        subject: "Docs",
      },
    ],
  },

  "docs.folder": {
    path: "/docs/folder/:folderId",
    component: Docs,
    abilities: [
      {
        action: "list_files",
        subject: "Docs",
      },
    ],
  },

  "docs.file": {
    path: "/docs/file/:fileId",
    component: Docs,
    abilities: [
      {
        action: "view_file",
        subject: "Docs",
      },
    ],
  },

  // Statistics.

  statistics: {
    path: "/statistics",
    label: I18n.get.statistics.labels.statistics,
  },

  "statistics.general": {
    path: "/statistics/general",
    label: I18n.get.statistics.labels.general,
    component: GeneralStatistics,
    abilities: [
      {
        action: "access",
        subject: "Statistics",
      },
    ],
  },
  "statistics.certifications": {
    path: "/statistics/certifications",
    label: I18n.get.statistics.labels.certifications,
    component: CertificationsStatistics,
    abilities: [
      {
        action: "access",
        subject: "Statistics",
      },
    ],
  },

  // Settings.

  settings: {
    path: "/settings",
    label: I18n.get.misc.settings,
    component: Settings,
    abilities: [
      {
        action: "manage",
        subject: "Settings",
      },
    ],
  },

  // Navigation.

  navigation: {
    path: "/navigation",
    label: I18n.get.misc.navigation,
  },

  "navigation.menus": {
    path: "/navigation/menus",
    label: I18n.get.menu.labels.menus,
    component: Menus,
    abilities: [
      {
        action: "list_menus",
        subject: "Navigation",
      },
    ],
  },

  "navigation.menus.name": {
    path: "/navigation/menus/:name",
    component: MenuEdit,
    abilities: [
      {
        action: "update_menu",
        subject: "Navigation",
      },
    ],
  },

  // Applications.

  "content.applications": {
    path: "/content/applications",
    label: I18n.get.application.labels.applications,
    component: Applications,
    abilities: [
      {
        action: "list",
        subject: "Applications",
      },
    ],
  },

  "content.applications.id": {
    path: "/content/applications/:id",
    component: ApplicationEdit,
    abilities: [
      {
        action: "update",
        subject: "Applications",
      },
    ],
  },
};

export default routes;
